var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcKnowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 15.0003V4.16699",
    stroke: "#4B5563",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8333C11.779 10.6226 11.1457 10.1839 10.695 9.58292C10.2443 8.98198 10.0005 8.25117 10 7.5C9.99955 8.25117 9.7557 8.98198 9.305 9.58292C8.8543 10.1839 8.221 10.6226 7.5 10.8333",
    stroke: "#4B5563",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.665 5.4171C14.8568 5.08501 14.9695 4.71325 14.9946 4.3306C15.0197 3.94794 14.9565 3.56464 14.8097 3.21035C14.663 2.85605 14.4367 2.54027 14.1484 2.28742C13.8601 2.03457 13.5175 1.85143 13.1471 1.75218C12.7766 1.65293 12.3884 1.64022 12.0123 1.71503C11.6361 1.78985 11.2823 1.95019 10.9781 2.18364C10.6738 2.41709 10.4274 2.71741 10.2578 3.06134C10.0882 3.40528 9.99998 3.78362 10 4.1671C10 3.78362 9.91181 3.40528 9.74222 3.06134C9.57262 2.71741 9.32617 2.41709 9.02194 2.18364C8.71771 1.95019 8.36386 1.78985 7.98775 1.71503C7.61164 1.64022 7.22336 1.65293 6.85294 1.75218C6.48253 1.85143 6.13992 2.03457 5.85161 2.28742C5.5633 2.54027 5.33702 2.85605 5.19028 3.21035C5.04353 3.56464 4.98026 3.94794 5.00536 4.3306C5.03046 4.71325 5.14324 5.08501 5.335 5.4171",
    stroke: "#4B5563",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9967 4.27051C15.4866 4.39646 15.9413 4.63222 16.3266 4.95993C16.7118 5.28765 17.0174 5.69874 17.2202 6.16205C17.423 6.62536 17.5178 7.12875 17.4973 7.6341C17.4767 8.13945 17.3415 8.6335 17.1018 9.07884",
    stroke: "#4B5563",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15.0003C15.7338 15.0002 16.447 14.7581 17.0291 14.3114C17.6112 13.8647 18.0297 13.2384 18.2196 12.5297C18.4095 11.8209 18.3603 11.0693 18.0795 10.3914C17.7987 9.7135 17.3021 9.14718 16.6667 8.78027",
    stroke: "#4B5563",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6392 14.5693C16.6976 15.0212 16.6627 15.4802 16.5368 15.9181C16.4108 16.356 16.1964 16.7634 15.9068 17.1151C15.6173 17.4669 15.2587 17.7556 14.8531 17.9633C14.4476 18.171 14.0038 18.2934 13.5492 18.3229C13.0945 18.3525 12.6386 18.2884 12.2097 18.1348C11.7807 17.9813 11.3878 17.7414 11.0552 17.43C10.7226 17.1186 10.4573 16.7423 10.2759 16.3244C10.0944 15.9065 10.0005 15.4558 9.99999 15.0002C9.99951 15.4558 9.90562 15.9065 9.72413 16.3244C9.54264 16.7423 9.2774 17.1186 8.94479 17.43C8.61219 17.7414 8.21927 17.9813 7.79032 18.1348C7.36136 18.2884 6.90547 18.3525 6.45081 18.3229C5.99614 18.2934 5.55235 18.171 5.14684 17.9633C4.74134 17.7556 4.38272 17.4669 4.09315 17.1151C3.80357 16.7634 3.58919 16.356 3.46323 15.9181C3.33728 15.4802 3.30242 15.0212 3.36083 14.5693",
    stroke: "#4B5563",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99986 15.0003C4.26611 15.0002 3.55286 14.7581 2.97075 14.3114C2.38863 13.8647 1.97017 13.2384 1.78026 12.5297C1.59034 11.8209 1.6396 11.0693 1.92037 10.3914C2.20115 9.7135 2.69776 9.14718 3.33319 8.78027",
    stroke: "#4B5563",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00325 4.27051C4.51342 4.39646 4.05867 4.63222 3.67345 4.95993C3.28822 5.28765 2.98262 5.69874 2.77979 6.16205C2.57696 6.62536 2.48222 7.12875 2.50275 7.6341C2.52327 8.13945 2.65852 8.6335 2.89826 9.07884",
    stroke: "#4B5563",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKnowledge);
export default __webpack_public_path__ + "static/media/ic_knowledge.4eb53c057cb4ea7867b69791aaf9483a.svg";
export { ForwardRef as ReactComponent };